import { Accordion } from '@talentmesh/ui/components/accordion';
import { Card, CardContent } from '@talentmesh/ui/components/card';
import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { useCreateRecruitmentContext } from '../../../Create/Contexts/CreateRecruitmentContext';
import { informationFormValues2Model, RequestInformationForm } from '../RequestInformationStepUtils';
import GeneralInformationAccordion from './accordions/GeneralInformationAccordion';
import MotivationalInformatioAccordion from './accordions/MotivationalInformatioAccordion';
import StartupInformationAccordion from './accordions/StartupInformationAccordion';
import UIStrings from '@/Utils/UIStrings';

const RequestInformationStepBody = () => {
    const { setApplicantInformation } = useCreateRecruitmentContext();
    const values = useWatch();

    useEffect(() => {
        setApplicantInformation(informationFormValues2Model(values as RequestInformationForm));
    }, [values]);

    return (
        <Card>
            <CardContent className="p-0">
                <Accordion type="multiple" defaultValue={[UIStrings.GeneralInformation]}>
                    <GeneralInformationAccordion />
                    <MotivationalInformatioAccordion />
                    <StartupInformationAccordion />
                </Accordion>
            </CardContent>
        </Card>
    );
};

export default RequestInformationStepBody;
